export default "__VITE_ASSET__CKI3JkB2__"